import React, { useContext, useEffect, useState } from "react";
import "./Withdrawl_Problem_List.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import Select from "react-select";
import { Tabs, Tab } from "react-bootstrap";
import Filter_Drop from "../Common/Common_Component/Filter_Drop/Filter_Drop";
import Withdrawal_History_card from "../Withdraw/Withdrawal_History/Withdrawal_History_card/Withdrawal_History_card";
import No_data from "../Common/No_data/No_data";
import { useDispatch, useSelector } from "react-redux";
import { GetAllWithdrawHistory } from "../../features/wallet/slice";
import { Context } from "../../utils/context";
import CustomPagination from "../Common/Common_Component/CustomPagination/CustomPagination";

function Withdrawl_Problem_List() {

  const [key, setKey] = useState("all");
  const [showDate, setShowDate] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedApp, setSelectedApp] = useState("All");
  const dispatch = useDispatch();
  const { signin } = useContext(Context)

  const withdrawHistory = useSelector((state) => state.wallet);

  const fetch = async (page) => {
    await dispatch(GetAllWithdrawHistory({
      page,
      startDate: selectedDate,
      status: selectedApp?.id
    }))
  };

  useEffect(() => {
    if (signin)
      fetch(1);
  }, [dispatch, signin, selectedDate, selectedApp]);

  const handlePageChange = async (page) => {
    fetch(page)
  };
  const options = [
    { label: "All", id: null },
    { label: "Pending", id: 1 },      // Processing
    { label: "Completed", id: 2 },    // Accepted
    { label: "Rejected", id: 3 }
  ];
  return (
    <>
      <section className="Withdrawl_Problem_List">
        <Common_white_header headingText={"Withdrawal History"} />

        <div className="container">
          {/* Cards */}
          {withdrawHistory?.data?.length > 0 ?
            <Withdrawal_History_card withdrawHistory={withdrawHistory} />
            :
            <No_data />
          }
        </div>

        {withdrawHistory?.total_pages > 1 &&
          <CustomPagination currentPage={withdrawHistory?.current_page}
            totalPages={withdrawHistory?.total_pages}
            handlePageChange={handlePageChange} />}
      </section>


    </>
  );
}

export default Withdrawl_Problem_List;
